const css = `._datepicker_wvx0o_1 {
  border: 1px solid var(--border-color);
  width: 100%;
  max-width: 280px;
}
._datepickerNavigation_wvx0o_6 {
  align-items: center;
  border-bottom: 1px solid var(--border-color);
  display: grid;
  gap: 4px;
  grid-template-columns: 40px 3fr 2fr 40px;
}
._datepickerNavigationButton_wvx0o_13 {
  border: 0 none transparent;
  height: 40px;
  width: 40px;
}
._datepickerCalendar_wvx0o_18 {
  background-color: var(--disabled-color);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
._datepickerCalendarButton_wvx0o_23 {
  border-color: transparent;
  height: 40px;
  width: 40px;
}
._datepickerCalendarDayOfWeek_wvx0o_28 {
  align-items: center;
  background-color: var(--bg-color);
  border-bottom: 1px solid var(--border-color);
  box-sizing: border-box;
  color: var(--secondary-text-color);
  cursor: default;
  display: flex;
  font-size: 0.7em;
  height: 40px;
  justify-content: center;
  padding: 4px;
  width: 40px;
}
._datepickerCalendarEmptyCell_wvx0o_42 {
  border: 0 none transparent;
  cursor: default;
  height: 40px;
  width: 40px;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "datepicker": "_datepicker_wvx0o_1",
  "datepickerNavigation": "_datepickerNavigation_wvx0o_6",
  "datepickerNavigationButton": "_datepickerNavigationButton_wvx0o_13",
  "datepickerCalendar": "_datepickerCalendar_wvx0o_18",
  "datepickerCalendarButton": "_datepickerCalendarButton_wvx0o_23",
  "datepickerCalendarDayOfWeek": "_datepickerCalendarDayOfWeek_wvx0o_28",
  "datepickerCalendarEmptyCell": "_datepickerCalendarEmptyCell_wvx0o_42"
};